import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TokenInterceptorService } from './service/token-interceptor.service';
import { AuthGuard } from './guard/auth.guard';
import { AuthService } from './service/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { ThemeService } from './service/theme.service';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

// 🔥 Registramos español
registerLocaleData(localeEs, 'es');

export function applyThemeOnStartup(themeService: ThemeService) {
  return () => themeService.applyStoredTheme();
}

@NgModule({ 
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], 
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        BrowserModule
    ], 
    providers: [
        AuthGuard,
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: applyThemeOnStartup,
            deps: [ThemeService],
            multi: true
        },
        // 🔥 Aquí agregamos LOCALE_ID en español
        {
            provide: LOCALE_ID,
            useValue: 'es'
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }
